export const N31 = {
    "columns": 8,
    "rows": 1,
    "visual": {
        "id": 4,
        "type": "treemap",
        "colorTheme": "colorTheme1",
        "title": "Share by District",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "title": 'DistrictGroupCode',
                "value": 'Share',
                "tooltip": 'ActualSales',
                "currency": true,
                "percent": true,
                "endpoint": "N31",
                "filter": {
                    "show": false,
                    "local": ["DistrictGroupCode"],
                },
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" },
                    { "key": "DistrictGroupCode", "value": '' },
                    { "key": "RegionCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "DistrictGroupCode",
                        "selectedTitle": "District Manager",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 2,
                                "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": 'colorTheme1',
                                    "title": "District Manager",
                                    "binding": {
                                        "data": {
                                            "columns": [
                                                {
                                                    "name": 'District Manager Name',
                                                    "columnName": 'DistrictManagerName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false,
                                                },
                                                {
                                                    "name": 'Actual Sales',
                                                    "columnName": 'ActualSales',
                                                    "width": '140px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'LY Sales',
                                                    "columnName": 'LYSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Growth %',
                                                    "columnName": 'Growth',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                },
                                                {
                                                    "name": 'Target',
                                                    "columnName": 'TargetSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Performance %',
                                                    "columnName": 'Performance',
                                                    "width": '150px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                }
                                            ],
                                            "title": "DistrictManagerName",
                                            "endpoint": "N31.1",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistrictGroupCode", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" },
                                                { "key": "RegionCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {
                                                    "selectedValueColumn": "DistrictGroupCodeDistrictManagerName",
                                                    "selectedTitle": "PMR",
                                                    "visuals": [
                                                        {
                                                            "title": "PMR",
                                                            "visual": [
                                                                {
                                                                    "columns": 12,
                                                                    "rows": 2,
                                                                    "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": 'colorTheme1',
                                                                        "title": "PMR",
                                                                        "binding": {
                                                                            "data": {
                                                                                "columns": [
                                                                                    {
                                                                                        "name": 'PMR Code',
                                                                                        "columnName": 'AgentCode',
                                                                                        "width": '150px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                    },
                                                                                    {
                                                                                        "name": 'Employee Code',
                                                                                        "columnName": 'EmployeeCode',
                                                                                        "width": '160px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                    },
                                                                                    {
                                                                                        "name": 'PMR Name',
                                                                                        "columnName": 'AgentName',
                                                                                        "width": '200px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                    },
                                                                                    {
                                                                                        "name": 'Actual Sales',
                                                                                        "columnName": 'ActualSales',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true,
                                                                                    },
                                                                                    {
                                                                                        "name": 'LY Sales',
                                                                                        "columnName": 'LYSales',
                                                                                        "width": '125px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true,
                                                                                    },
                                                                                    {
                                                                                        "name": 'Growth %',
                                                                                        "columnName": 'Growth',
                                                                                        "width": '125px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'Target',
                                                                                        "columnName": 'TargetSales',
                                                                                        "width": '125px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true,
                                                                                    },
                                                                                    {
                                                                                        "name": 'Performance %',
                                                                                        "columnName": 'Performance',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    }
                                                                                ],
                                                                                "title": "AgentName",
                                                                                "endpoint": "N31.2",
                                                                                "parameters": [
                                                                                    { "key": "FromMonth", "value": "2024" },
                                                                                    { "key": "FromYear", "value": "1" },
                                                                                    { "key": "ToMonth", "value": "2024" },
                                                                                    { "key": "ToYear", "value": "1" },
                                                                                    { "key": "DistrictGroupCodeDistrictManagerName", "value": "" },
                                                                                    { "key": "ConfigTypeCode", "value": "" },
                                                                                    { "key": "RegionCode", "value": "" }
                                                                                ]
                                                                            },
                                                                            "context": {
                                                                                "point": {
                                                                                    "onClick": {

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "title": "Product Group",
                                                            "visual": [
                                                                {
                                                                    "columns": 12,
                                                                    "rows": 2,
                                                                    "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": 'colorTheme1',
                                                                        "title": "Product Group",
                                                                        "binding": {
                                                                            "data": {
                                                                                "columns": [
                                                                                    {
                                                                                        "name": 'Item Group',
                                                                                        "columnName": 'ItemDivisionCode',
                                                                                        "width": '200px',
                                                                                        "align": "left",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                    },
                                                                                    {
                                                                                        "name": 'Actual Sales',
                                                                                        "columnName": 'ActualSales',
                                                                                        "width": '140px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true,
                                                                                    },
                                                                                    {
                                                                                        "name": 'LY Sales',
                                                                                        "columnName": 'LYSales',
                                                                                        "width": '125px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true,
                                                                                    },
                                                                                    {
                                                                                        "name": 'Growth %',
                                                                                        "columnName": 'Growth',
                                                                                        "width": '125px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    },
                                                                                    {
                                                                                        "name": 'Target',
                                                                                        "columnName": 'TargetSales',
                                                                                        "width": '125px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": true,
                                                                                    },
                                                                                    {
                                                                                        "name": 'Performance %',
                                                                                        "columnName": 'Performance',
                                                                                        "width": '150px',
                                                                                        "align": "right",
                                                                                        "sortable": true,
                                                                                        "sum": false,
                                                                                        "percent": true
                                                                                    }
                                                                                ],
                                                                                "title": "ItemDivisionCode",
                                                                                "endpoint": "N31.3",
                                                                                "parameters": [
                                                                                    { "key": "FromMonth", "value": "2024" },
                                                                                    { "key": "FromYear", "value": "1" },
                                                                                    { "key": "ToMonth", "value": "2024" },
                                                                                    { "key": "ToYear", "value": "1" },
                                                                                    { "key": "DistrictGroupCodeDistrictManagerName", "value": "" },
                                                                                    { "key": "ConfigTypeCode", "value": "" },
                                                                                    { "key": "RegionCode", "value": "" }
                                                                                ]
                                                                            },
                                                                            "context": {
                                                                                "point": {
                                                                                    "onClick": {

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}